
    import "src/app/AppSeller/SettingsPage/StoreAddress/components/RequestNewAddress/index.module.scss?farm_css_modules";
    
    export default {"Checkbox": `Checkbox-716544b1`,"shippingAddress": `shippingAddress-716544b1`,"subHeading": `subHeading-716544b1`}
    